import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Popover, PopoverHeader, PopoverBody, FormGroup, Label, Button } from 'reactstrap';
import Select from 'react-select'; 
import { map, filter as _filter, indexOf } from 'lodash';
import { FaSort, FaFilter } from 'react-icons/fa';
import * as Helpers from '../../../Utilities/Common';

class Filter extends Component {
    constructor(props){
        super(props);
        const { query, query: { order = "", sort = "" } } = props;
        this.toggle = this.toggle.bind(this);
        this.state = {
            popover: false,
            sort: props.field,
            order: sort === props.field ? order : "",
            [props.field]: query[props.field] === undefined ? "": query[props.field],
        };
        this.orderOptions = [{id: "asc", name: "A->Z"},{id: "desc", name: "Z->A"}];
    }

    toggle() {
        const { popover } = this.state;
        this.setState({
            popover: !popover
        });
    }

    applyFilters = () => {
        const { sort, order } = this.state;
        const { filter, token, field, pid=true } = this.props;
        const value = this.state[field];
        const query = {page: 1, sort, order};
        if(value !== "") query[field] = value;
        filter(token,query,pid);
    }

    sort = () => {
        this.setState((state) => {
            const value = state.order === "asc" ? "desc" : "asc";
            return {...state, order: value}
        },this.applyFilters);
    }

    setField = (endpoint, option, type = 0 ) => {
        Helpers.setField(endpoint, option, type, (dataObj) => {
            
            this.setState((state) => ({popover: state.popover, ...dataObj}));
        });
    }

    handleChange = (endpoint, options ) => {
        this.setState((state) => {
            const arr = map(options, "id");
            return {...state, [endpoint]: arr};
        
        });
    }

    getValues = () => {
        const { field = "", data = {} } = this.props;
        return _filter(data,(option) => indexOf(this.state[field],option.id) !== -1)
    };
    
    render(){
        const { id = "", title = "", field = "", data = {} } = this.props;
        const { popover, order } = this.state;
        const color = popover || this.state[field].constructor === Array ? "#337ab7": "#d1d1d1";
        const arrowColor = order === "asc" || order === "desc" ? "#337ab7": "#d1d1d1";
        return (
            <div>
                <span> { title } { Object.keys(data).length > 0 ? <FaFilter size={12} color={color} style={{verticalAlign: "middle"}} id={id} onClick={this.toggle} />: ""} <FaSort size={12} color={arrowColor} style={{verticalAlign: "middle"}} onClick={() => this.sort()} /></span> 
                {Object.keys(data).length > 0 ? 
                <Popover placement="bottom" isOpen={popover} style={{width:"250px"}} target={id} toggle={this.toggle}>
                    <PopoverHeader>Filter</PopoverHeader>
                    <PopoverBody>
                        <FormGroup>
                            <Label>
                                { title }
                            </Label>
                            <Select
                                isMulti
                                value={this.getValues()}
                                onChange={(value) => this.handleChange(field,value)}
                                options={ data }
                                getOptionLabel={(option) => option.name}
                                getOptionValue={(option) => option.id}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Button onClick={this.applyFilters} color="primary">Filter</Button>
                        </FormGroup>
                    </PopoverBody>
                </Popover>
                : "" }
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    token: state.auth.token,
});

export default connect(mapStateToProps)(Filter);


// WEBPACK FOOTER //
// ./src/Components/App/Layout/Filter.js